import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import "./ComparePlans.scss";
import AllDataClass from "pages/common/AllDataClass";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { SparkLineChart } from "@mui/x-charts/SparkLineChart";
import { ChartsReferenceLine } from "@mui/x-charts/ChartsReferenceLine";
import { lineElementClasses } from "@mui/x-charts/LineChart";
import GameService from "../../service/GameService";
import AddGameModal from "./AddGameModal";
import SaveCompareId from "./SaveCompareId";
import { uniqueNamesGenerator, Config, adjectives, colors, animals } from "unique-names-generator";
import YoungSad from "../../images/young_sad.png";
import YoungHappy from "../../images/young_happy.png";
import OldSad from "../../images/old_sad.png";
import OldHappy from "../../images/old_happy.png";

const config: Config = {
  separator: "-",
  dictionaries: [adjectives, colors, animals],
};

const ComparePlans = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const maxPolicyCnt = 8;
  const [searchParams, setSearchParams] = useSearchParams();
  const [name, setName] = useState("");
  const [goals, setGoal] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [debt, setDebt] = useState([]);
  const [pyi, setPYI] = useState(0.0);
  const [score, setScore] = useState([]);
  const [create, setCreate] = useState("");
  const [compareId, setCompareId] = useState(searchParams.get("cmpid") || "");
  const [gamedataList, setGameDataList] = useState([]);
  const [gameidlist, setGameIdList] = useState([]);
  const [open, setOpen] = useState(false);
  const [openAddGame, setOpenAddGame] = useState(false);
  const [openCompare, setOpenCompare] = useState(false);
  const [openViewPlan, setOpenViewPlan] = useState(false);
  const handleClose = () => setOpen(false);
  const handleCloseAddGame = () => setOpenAddGame(false);
  const handleCloseCompare = () => setOpenCompare(false);
  const [selectedPolicyLists, setSelectedPolicyLists] = useState([]);
  const [showPolicies, setShowPolicies] = useState<any[]>(selectedPolicyLists);
  const [policyCnt, setPolicyCnt] = useState(0);
  const [pageCnt, setPageCnt] = useState(0);
  const [curPage, setCurPage] = useState(0);
  const [detailPolicy, setDetailPolicy] = useState({});
  const [detailPolicycategory, setDetailPolicyCategory] = useState("");
  const [policyModalOpen, setPolicyModalOpen] = useState(false);
  const [starScore, setStarScore] = useState([]);
  const AllPolicies = AllDataClass.getPolicyDescriptives();
  const [policyImpact, setPolicyImpact] = useState([]);
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [gameid, setGameId] = useState("");
  const [username, setUserName] = useState("");
  const [debtGoalMeet, setDebtGoalMeet] = useState(false);
  const [GoalMeet, setGoalMeet] = useState(false);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [isCandidate, setIsCandidate] = useState(false);

  const maxSwiperCnt = 10;

  useEffect(() => {
    setCompareId(searchParams.get("cmpid"));
    console.log(searchParams.get("cmpid"));
    getSwiperSlide();
    // console.log(compareId);
  }, []);

  useEffect(() => {
    if (swiperInstance && swiperInstance.params && swiperInstance.params.navigation) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  const getGoalScore = (starScore: number[]) => {
    var retVal = true;
    starScore.forEach((score) => {
      retVal = retVal && score >= 3;
    });
    return retVal;
  };

  const showPlan = (gamedata: any) => {
    console.log(gamedata);
    var score = JSON.parse(gamedata.score);
    var goals = JSON.parse(gamedata.goal);
    var policy = JSON.parse(gamedata.policy);
    var debt = JSON.parse(gamedata.debt);
    setDebt(debt);
    setDebtGoalMeet(debt[debt.length - 1] <= 150);
    setStarScore([...score]);
    setSelectedGoals([...goals]);
    setSelectedPolicyLists([...policy]);
    setPolicyCnt(selectedPolicyLists.length);
    setGameId(gamedata.gameId);
    setUserName(gamedata.name);
    setGoalMeet(getGoalScore(score));
    setPYI(gamedata.pyi);
    var policycnt = policy.length;
    var pagecnt = 0;
    if (policycnt >= maxPolicyCnt && policycnt % maxPolicyCnt == 0) {
      pagecnt = Math.floor(policycnt / maxPolicyCnt) - 1;
    } else {
      pagecnt = Math.floor(policycnt / maxPolicyCnt);
    }
    setPolicyImpact(AllDataClass.getPolicyGovGoalImpactsForGoals(policy));
    if (policy.length > 0) {
      var showlists = policy.slice(0, maxPolicyCnt);
      setShowPolicies([...showlists]);
    }

    setPageCnt(pagecnt);
    setOpenViewPlan(true);
  };
  const genCompareHtml = (gamedata: any, idx: number) => {
    var retVal;
    var goalVal = new Array();
    var debts = JSON.parse(gamedata.debt);
    var goals = JSON.parse(gamedata.goal);
    var score = JSON.parse(gamedata.score);
    var policy = JSON.parse(gamedata.policy);
    var pyiIdx = JSON.parse(gamedata.pyi);
    for (var i = 0; i < goals.length; i++) {
      goalVal.push(
        <div className="compareplan-goal">
          <div className={`compareplan-goal-image ${goals[i].goalid}`}>
            {score[i] >= 3 && <div className="goal-star2" />}
            {score[i] >= 1 && <div className="goal-star1" />}
            {score[i] >= 4 && <div className="goal-star3" />}
          </div>
        </div>
      );
    }
    retVal = (
      <SwiperSlide className="swiperslide" key={idx}>
        <div className="title">
          {gamedata.name === "이재명 후보님11" || gamedata.name === "김문수 후보님11"
            ? `${gamedata.name === "이재명 후보님11" ? t("candidate1-res") : t("candidate2-res")}`
            : `${gamedata.name} ${t("userplan")}`}
        </div>
        <div className="debt-goal-text" key={idx}>
          {t("deptratio-text", {
            // name: gamedata.name,
            debtratio: Number(debts[debts.length - 1].toFixed(1)),
          })}
        </div>
        <div className="graph-wrap">
          <SparkLineChart
            className="graph"
            data={debts}
            sx={{
              [`& .${lineElementClasses.root}`]: {
                strokeWidth: 4,
              },
            }}
            yAxis={{
              min: 50,
              max: 200,
            }}
            colors={["yellow"]}
          >
            <ChartsReferenceLine
              y={150}
              label=""
              lineStyle={{ strokeDasharray: "10 5", strokeWidth: 4, stroke: "gray" }}
            />
          </SparkLineChart>
        </div>
        <div className="debt-goal-text" key={idx}>
          {t("pyi-ratio-text", {
            // name: gamedata.name,
            pyiIdx: Number(pyiIdx.toFixed(1)),
          })}
        </div>
        <div className="pyi-result-wrap">
          <div className="pyi-result young">
            <img
              className="pyi-result-img"
              src={Number(pyiIdx.toFixed(1)) - 31.8 < 0 ? YoungHappy : YoungSad}
            />
          </div>
          <div className="pyi-result old">
            <img
              className="pyi-result-img"
              src={Number(pyiIdx.toFixed(1)) - 31.8 >= 0 ? OldHappy : OldSad}
            />
          </div>
        </div>
        <div className="compareplan-goal-wrap">{goalVal}</div>
        <div className="selectedPolicy">{t("cmpapre-selectpolicy", { cnt: policy.length })}</div>
        <button className="view-plan-button" onClick={() => showPlan(gamedata)}>
          <span>{t("view-plan")}</span>
        </button>
      </SwiperSlide>
    );
    return retVal;
  };
  const addPlan = () => {
    setOpenAddGame(true);
  };
  const getEmptySwiperSlide = (idx: number) => {
    return (
      <SwiperSlide className="swiperslide" key={idx}>
        <div className="add-plan">
          <button className="add-button" onClick={addPlan} />
          <div className="add-plan-text">{t("addplan")}</div>
        </div>
      </SwiperSlide>
    );
  };
  const getSwiperSlide = async () => {
    var swiperslice = new Array();
    try {
      if (compareId?.length > 0) {
        var res = await GameService.getComparison(compareId);
        var gamedatas = res.data.comparison;
        var length: number = gamedatas.length;
        var gameidlists = new Array();
        console.log(gamedatas);
        gamedatas.forEach((gamedata: any) => {
          gameidlists.push(gamedata.gameId);
          if (gamedata.name === "이재명 후보님11" || gamedata.name === "김문수 후보님11") {
            setIsCandidate(true);
          }
        });
        setGameIdList([...gameidlists]);
        // 데이터 가져오기 실패나 정보가 없는 경우
        if (!gamedatas || gamedatas.length <= 0) return;
        if (length < 3) {
          for (var i = 0; i < length; i++) {
            swiperslice.push(genCompareHtml(gamedatas[i], i));
          }
          for (var i = 0; i < 3 - length; i++) {
            if (
              !(gamedatas[0].name === "이재명 후보님11" || gamedatas[0].name === "김문수 후보님11")
            ) {
              swiperslice.push(getEmptySwiperSlide(i + length));
            }
          }
        } else if (length < maxSwiperCnt) {
          var i = 0;
          for (; i < length; i++) {
            swiperslice.push(genCompareHtml(gamedatas[i], i));
          }
          swiperslice.push(getEmptySwiperSlide(i));
        } else {
          for (var i = 0; i < length || i < maxSwiperCnt; i++) {
            swiperslice.push(genCompareHtml(gamedatas[i], i));
          }
        }
      } else {
        const randomName = uniqueNamesGenerator(config);
        setCompareId(randomName);
      }
      setGameDataList(swiperslice);
    } catch (error) {
      console.log(error);
    }
  };

  const handleReload = () => {
    getSwiperSlide();
    return;
  };

  const viewPlainGoalList = () => {
    var goal_list = new Array();
    var points = starScore;

    selectedGoals.map((selectedGoal: any, idx: number) => {
      var starPoint = points[idx];

      goal_list.push(
        <div className={`goal-image ${selectedGoal.goalid}`} key={idx}>
          {starPoint >= 1 && <div className="compareplan-goal-star1" />}
          {starPoint >= 3 && <div className="compareplan-goal-star2" />}
          {starPoint >= 4 && <div className="compareplan-goal-star3" />}
        </div>
      );
    });
    return goal_list;
  };

  const handleCopyClipBoard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("copied");
    } catch (e) {
      alert("failed");
    }
  };

  const closePlan = () => {
    setOpenViewPlan(false);
    setCurPage(0);
  };

  const showSlectedPolicy = (policyid: string) => {
    // console.log(AllDataClass.getPolicyDescriptivebyID(policyid));
    var policy: any = {};
    policy[policyid] = AllDataClass.getPolicyDescriptivebyID(policyid);
    // console.log(policy);
    setDetailPolicy(policy);
    setDetailPolicyCategory(policy[policyid][0]);
    setPolicyModalOpen(true);
  };
  const getGoalImpact = (policyid: any) => {
    var impact_list = new Array();
    if (selectedPolicyLists.length <= 0) return impact_list;
    selectedGoals.map((selectedGoal: any, idx: number) => {
      var goalIdx = Number(selectedGoal.goalid.substring(1));
      // console.log(goalIdx);
      // console.log(policyImpact);
      var impact = policyImpact[policyid][0][goalIdx];
      // console.log(impact);
      var classname = "";
      if (impact == 1) {
        classname = "smallup";
      } else if (impact == 2) {
        classname = "bigup";
      } else if (impact == -1) {
        classname = "smalldown";
      } else if (impact == -2) {
        classname = "bigdown";
      } else {
        classname = "none";
      }
      impact_list.push(
        <div className={`impact ${classname} ${selectedGoal.goalid}`} key={idx}></div>
      );
    });
    return impact_list;
  };
  const clickPrevBtn = () => {
    console.log("clickPrevBtn", curPage, pageCnt);
    var curpage = curPage;
    if (curpage > 0) {
      curpage--;
      setCurPage(curpage);
    }
    if (selectedPolicyLists.length > curpage * maxPolicyCnt) {
      setShowPolicies(
        selectedPolicyLists?.slice(curpage * maxPolicyCnt, curpage * maxPolicyCnt + maxPolicyCnt)
      );
    }
  };

  const clickNextBtn = () => {
    console.log("clickNextBtn", curPage, pageCnt);
    var curpage = curPage;
    if (curpage < pageCnt && curpage >= 0) {
      curpage++;
      setCurPage(curpage);
      if (selectedPolicyLists.length > curpage * maxPolicyCnt) {
        setShowPolicies(
          selectedPolicyLists?.slice(curpage * maxPolicyCnt, curpage * maxPolicyCnt + maxPolicyCnt)
        );
      } else {
        curpage--;
        setCurPage(curpage);
      }
    }
  };

  const checkGoalMeet = () => {
    var retVal = true;
    var fullmeet = 0;
    var partialmeet = 0;
    starScore.forEach((score) => {
      if (score >= 4) {
        retVal = retVal && true;
        fullmeet++;
        partialmeet++;
      } else if (score >= 3) {
        partialmeet++;
      } else {
        retVal = false;
      }
    });

    return (
      <div className="explain">
        {fullmeet == 3
          ? t("goal-full-meet-text")
          : partialmeet == 3
            ? t("goal-partial-meet-text")
            : t("goal-fail-text")}
      </div>
    );
  };

  return (
    <div className="compareplan-root">
      <AddGameModal
        open={openAddGame}
        handleClose={handleCloseAddGame}
        handleReload={handleReload}
        setGameIdList={setGameIdList}
        compid={compareId}
        gameids={gameidlist}
      />
      <SaveCompareId open={openCompare} handleClose={handleCloseCompare} compid={compareId} />
      <div className="background-tower" />
      <button className="save-button" onClick={() => setOpenCompare(true)} />
      <div className="compareplan-title-wrap">
        <div className="compareplan-title">{t("gamename")}</div>
        {isCandidate === true ? (
          <div className="compareplan-explain">{t("compare-res")}</div>
        ) : (
          <div className="compareplan-explain">{t("compareplan")}</div>
        )}
      </div>
      <div className="compareplan-content-wrap">
        {isCandidate === true ? (
          <div className="compareplan-plan-wrap">
            <div className="mySwiper center">{gamedataList}</div>
          </div>
        ) : (
          <div className="compareplan-plan-wrap">
            <Swiper
              slidesPerView={3}
              spaceBetween={10}
              loop={true}
              onSwiper={setSwiperInstance} // Store Swiper instance
              // autoplay={{
              //   delay: 5000,
              //   disableOnInteraction: false,
              // }}
              pagination={{
                clickable: true,
              }}
              navigation={true}
              modules={[Autoplay, Pagination, Navigation]}
              className="mySwiper"
            >
              {gamedataList?.length > 0 ? (
                gamedataList
              ) : (
                <>
                  <SwiperSlide className="swiperslide">
                    <div className="add-plan">
                      <button className="add-button" onClick={addPlan} />
                      <div className="add-plan-text">{t("addplan")}</div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiperslide">
                    <div className="add-plan">
                      <button className="add-button" onClick={addPlan} />
                      <div className="add-plan-text">{t("addplan")}</div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide className="swiperslide">
                    <div className="add-plan">
                      <button className="add-button" onClick={addPlan} />
                      <div className="add-plan-text">{t("addplan")}</div>
                    </div>
                  </SwiperSlide>
                </>
              )}
              <div className="swiper-button-wrap">
                <button className="custom-button prev" ref={prevRef} />
                <button className="custom-button next" ref={nextRef} />
              </div>
            </Swiper>
          </div>
        )}
        <div className="compareplan-button-wrap">
          <button className="exit-button" onClick={() => navigate("/")}>
            <span>{t("exit")}</span>
          </button>
        </div>
      </div>
      <div className="compareplan-modal" style={openViewPlan ? {} : { display: "none" }}>
        <div className="compareplan-background" />
        <div className="compareplan-modal-content">
          <div className="plan-explain">
            <div className="plan-explain-title-wrap">
              <div className={`plan-explain-title ${!debtGoalMeet && "fail"}`}>
                <span>
                  {debtGoalMeet
                    ? t("debtgoal-meet")
                        .split("\n")
                        .map((item: any, idx: number) => <div key={idx}>{item}</div>)
                    : t("debtgoal-fail")
                        .split("\n")
                        .map((item: any, idx: number) => <div key={idx}>{item}</div>)}
                </span>
              </div>
              <div className={`plan-explain-title ${!GoalMeet && "fail"}`}>
                <span>
                  {GoalMeet
                    ? t("goal-meet")
                        .split("\n")
                        .map((item: any, idx: number) => <div key={idx}>{item}</div>)
                    : t("goal-fail")
                        .split("\n")
                        .map((item: any, idx: number) => <div key={idx}>{item}</div>)}
                </span>
              </div>
            </div>
            <div className="plan-explain-contents">
              <div className="row-wrap">
                <div className="bullet" />
                <div className="explain">
                  {t("debtgoal-text", {
                    debtratio: debt[debt?.length - 1]?.toFixed(1),
                    archive: debt[debt.length - 1] > 150 ? t("archive-fail") : t("archive-meet"),
                  })}
                </div>
              </div>
              <div className="row-wrap">
                <div className="bullet" />
                <div className="explain">
                  {t("PYI-text", {
                    pyi: pyi?.toFixed(1),
                    level:
                      pyi - 31.8 == 0
                        ? t("equal-pyi")
                        : pyi - 31.8 > 0
                          ? t("upper-pyi")
                          : t("lower-pyi"),
                    generation: pyi - 31.8 >= 0 ? t("future-gen") : t("current-gen"),
                  })}
                </div>
              </div>
              <div className="row-wrap">
                <div className="pyi-result-wrap">
                  <div className="pyi-result young">
                    <img className="pyi-result-img" src={pyi - 31.8 < 0 ? YoungHappy : YoungSad} />
                  </div>
                  <div className="pyi-result old">
                    <img className="pyi-result-img" src={pyi - 31.8 >= 0 ? OldHappy : OldSad} />
                  </div>
                </div>
              </div>
              <div className="row-wrap">
                <div className="bullet" />
                {checkGoalMeet()}
                {/* <div className="explain">
                  {GoalMeet == true ? t("goal-meet-text") : t("goal-fail-text")}
                </div> */}
              </div>
            </div>
            <div className="plan-explain-id">
              <div className="saveid">
                SavelD:&nbsp;
                <span>{gameid}</span>
              </div>
              <div className="btn-copy-id" onClick={() => handleCopyClipBoard(gameid)}></div>
            </div>
          </div>
          <div className="plan-list">
            <div className="plan-list-title">
              {username === "이재명 후보님11" || username === "김문수 후보님11" ? (
                <span>
                  {username === "이재명 후보님11"
                    ? t("candidate1-detail-res")
                    : t("candidate2-detail-res")}
                </span>
              ) : (
                <span>
                  {username}
                  {t("userplan")}
                </span>
              )}
              <div className="plan-close-btn" onClick={closePlan} />
            </div>
            <div className="plan-lists">
              <div className="goal-wrap">
                <div className="goals">{viewPlainGoalList()}</div>
              </div>
              <div className="plans">
                {showPolicies.map((policyid: any, idx: number) => (
                  <div className="row" key={idx}>
                    <div
                      className="bullet"
                      // onClick={() => {
                      //   showSlectedPolicy(policyid);
                      // }}
                    ></div>
                    <div className="policyname">
                      {AllPolicies[policyid] && AllPolicies[policyid][2]}
                    </div>
                    <div className="impacts">{getGoalImpact(policyid)}</div>
                  </div>
                ))}
              </div>
              <div className="sub-buttons">
                <button
                  className="view-plan-prev"
                  disabled={curPage == 0}
                  onClick={() => clickPrevBtn()}
                />
                <button
                  className="view-plan-next"
                  disabled={curPage == pageCnt}
                  onClick={() => clickNextBtn()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparePlans;
